import React from 'react';
import { inject, observer } from 'mobx-react';

import ArtistsListSection from '../artists-list-section.js/artists-list-section';

@inject('artistStore')
@observer
class TopArtists extends React.Component {
	render() {
		const { artistStore } = this.props;

		if (artistStore.isLoading) {

			return (<h1>Loading...</h1>);
		}

		return (
			<div>
				<ArtistsListSection
					sectionLabel="Top Selling Artists"
					artists={ artistStore.topSelling } />

				<ArtistsListSection
					sectionLabel="Most HiFived Artists"
					artists={ artistStore.trending } />

				<ArtistsListSection
					sectionLabel="Top Trending Artists"
					artists={ artistStore.mostHiFived } />
			</div>
		);
	}
}

export default TopArtists;
